const logCitationClickDPL = () => {
  // selects all links in the content that go to a different domain
  const linkSelector = `a:not([href^='${window.location.origin}'])`;
  let citationLinks = document.querySelectorAll(`article.content ${linkSelector}`);
  citationLinks = citationLinks.length > 0 ? citationLinks : document.querySelectorAll(`article:has(#content) ${linkSelector}`); // also select links on activebeat old template

  if (citationLinks) {
    citationLinks.forEach((a) => {
      a.addEventListener('click', () => {
        const { DPL } = window.s1;

        if (DPL) {
          const payload = {
            site: window.location.host,
            url: a.href,
          };
          try {
            DPL.events.publishing.PublishingCitationClick.log(payload);
          } catch {
            console.warn('Could not log DPL PublishingCitationClick event');
          }
        } else {
          console.warn('Cannot log DPL PublishingCitationClick because s1.DPL is undefined');
        }
      });
    });
  }
};

export default logCitationClickDPL;
